export default __webpack_public_path__ + "static/media/lxwm.eb843f43.png";